import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0678cd7f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = { class: "DialogSection" }
const _hoisted_6 = {
  class: "DialogSection FlexColumn",
  style: {"width":"60%","flex":"auto"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "DialogHeaderButton" }, "Benifits", -1))
const _hoisted_10 = {
  key: 1,
  class: "CookiesDialogFooter"
}
const _hoisted_11 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.Access(_ctx.DialogData.Editing ? 'HR_Positions_Edit': 'HR_Positions_Create'))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: 'CookiesDialog_' + _ctx.DialogIndex,
          class: "CookiesDialogdBody"
        }, [
          (_ctx.Saving)
            ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.Loading.length > 0)
            ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_CookiesNormalInput, {
                    Placeholder: 'Name',
                    CookiesInvalidInput: !_ctx.MEMRead('D_Position_Name') && _ctx.MEMRead('D_Position_Name') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Position_Name') && _ctx.MEMRead('D_Position_Name') === ''),
                    Res: 'D_Position_Name',
                    Default: ''
                  }, null, 8, ["CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesDropInputObject, {
                    Name: _ctx.Translate('Department Name'),
                    Default: '',
                    Options: _ctx.Departments,
                    Selectors: ['Name'],
                    CookiesInvalidInput: !_ctx.MEMRead('D_Position_DepartmentName') && _ctx.MEMRead('D_Position_DepartmentName') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Position_DepartmentName') && _ctx.MEMRead('D_Position_DepartmentName') === ''),
                    Res: 'D_Position_DepartmentName'
                  }, null, 8, ["Name", "Options", "CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesDropInputObject, {
                    Name: _ctx.Translate('Shift'),
                    Default: '',
                    RowHeight: '3em',
                    Options: _ctx.Shifts,
                    Selectors: ['Name'],
                    CookiesInvalidInput: !_ctx.MEMRead('D_Empolyee_Shift') && _ctx.MEMRead('D_Empolyee_Shift') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Empolyee_Shift') && _ctx.MEMRead('D_Empolyee_Shift') === ''),
                    Res: 'D_Empolyee_Shift'
                  }, null, 8, ["Name", "Options", "CookiesInvalidInput", "ErrorData"])
                ])
              ]),
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _createVNode(_component_CookiesTable, {
                class: "Shadow1",
                TableSettings: _ctx.TableSettings,
                CookiesData: _ctx.CookiesData,
                Search: '',
                Loading: (_ctx.Loading.length > 0),
                SavingTable: (_ctx.SavingTable.length > 0),
                Saved: _ctx.Saved
              }, null, 8, ["TableSettings", "CookiesData", "Loading", "SavingTable", "Saved"])
            ])
          ])
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.Access(_ctx.DialogData.Editing ? 'HR_Positions_Edit': 'HR_Positions_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Close')), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              class: "F-Bold CookiesButton DialogFooterButton BGMain"
            }, _toDisplayString(_ctx.Translate('Save')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}